<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="notification_icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_4" data-name="Group 4">
      <path
        id="Path_1418"
        data-name="Path 1418"
        d="M9.708,18.344v.365A2.292,2.292,0,0,0,12,21h0a2.292,2.292,0,0,0,2.292-2.292v-.365"
        fill="none"
        :stroke="clr ? clr : '#002'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        id="Path_1419"
        data-name="Path 1419"
        d="M13.833,5.751V4.833A1.833,1.833,0,0,0,12,3h0a1.833,1.833,0,0,0-1.833,1.833v.918"
        fill="none"
        :stroke="clr ? clr : '#002'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        id="Path_1420"
        data-name="Path 1420"
        d="M6.563,10.188h0a4.531,4.531,0,0,1,4.531-4.531h1.813a4.531,4.531,0,0,1,4.531,4.531h0v2.8a2,2,0,0,0,.586,1.414l.641.641a2,2,0,0,1,.586,1.414h0a1.89,1.89,0,0,1-1.89,1.89H6.64a1.89,1.89,0,0,1-1.89-1.89h0a2,2,0,0,1,.586-1.414l.641-.641a2,2,0,0,0,.586-1.414v-2.8Z"
        fill="none"
        :stroke="clr ? clr : '#002'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </g>
    <path id="Path_1421" data-name="Path 1421" d="M0,0H24V24H0Z" fill="none" />
  </svg>
</template>
